import React, { useContext } from "react";
import { DF_LO0022Context } from "../context";
import RotaFreteForm from "../../DF_LO0021/Grid/RotaFreteForm";

function GridBody({ ID_Tabela_Frete: ID_Tabela_Frete_Prop, onClose, onSaved } = {}) {
  const ctx = useContext(DF_LO0022Context);
  const ID_Tabela_Frete = ID_Tabela_Frete_Prop ?? ctx?.ID_Tabela_Frete;
  return <RotaFreteForm mode="edit" ID_Tabela_Frete={ID_Tabela_Frete} onClose={onClose} onSaved={onSaved} />;
}

export default GridBody;